<template>
	<v-container>
		<v-row class="contentRow">
			<v-col cols="12">
				<v-tabs background-color="transparent" light centered icons-and-text>
					<v-tab>
						Active
					</v-tab>
					<v-tab>
						Inactive
					</v-tab>
					<v-tab>
						Not Approved
					</v-tab>
					<v-tab-item>
						<v-col cols="12" class="pt-10">
							<h1 class="mb-2 font-weight-black darkColor--text">Onsite-Audit Template Overview</h1>
							<p class="mb-5 text-center font-weight-medium darkColor--text">This is an overview of the
								templates you have
								available.</p>
						</v-col>
						<v-col align="right" v-if="$accessToOperation('AT', 'C')">
							<v-btn @click="dialogNewTemplate = true" dark color="primary" style="font-weight: 300;">
								<v-icon left small>fas fa-plus</v-icon>New Template
							</v-btn>
						</v-col>
						<v-col cols="12" class="pt-8">
							<v-card elevation="0" outlined>
								<v-data-table :loading="loading" theme-- light :headers="headers"
									:items="activeapprovedtemplates" :footer-props="{
										'items-per-page-options': [5, 10, 15]
									}" :items-per-page="5" class="light table">
									<template v-slot:item.name="{ item }">
										{{ item.name }}
										<!-- <v-chip class="ma-2" color="info" label small v-if="item.flowDown">
											<v-icon left small>
												fas fa-turn-down
											</v-icon>
											Flow Down
										</v-chip> -->
									</template>
									<template v-slot:item.edit="{ item }">
										<v-btn small :to="'/auditonsite/onsitetemplates/' + item.templateID" color="primary"
											style="border-radius: 2px" label>
											{{ item.edit }}
											<v-icon small>fas fa-edit</v-icon>
										</v-btn>
									</template>
									<template v-slot:item.remove="{ item }">
										<v-btn v-on:click="makeitInactive(item)" v-if="item.active"
											class="error--text font-italic font-weight-bold">Deactivate</v-btn>
										<v-btn v-on:click="makeitActive(item)" v-else
											class="success--text font-weight-bold">Activate</v-btn>
									</template>
									<template v-slot:item.active="{ item }">
										<span v-if="item.active" class="success--text font-weight-bold">Active</span>
										<span v-else class="error--text font-italic font-weight-bold">Inactive</span>
									</template>
									<template v-slot:item.approval="{ item }">
										<span v-if="!!item.approval" class="success--text font-weight-bold">Approved</span>
										<span v-else class="error--text font-italic font-weight-bold">Not Approved</span>
									</template>
								</v-data-table>
							</v-card>
						</v-col>
					</v-tab-item>
					<v-tab-item>
						<v-col cols="12" class="pt-10">
							<h1 class="mb-2 font-weight-black darkColor--text">Onsite-Audit Template Overview</h1>
							<p class="mb-5 text-center font-weight-medium darkColor--text">This is an overview of the
								templates you have
								available.</p>
						</v-col>
						<v-col align="right" v-if="$accessToOperation('AT', 'C')">
							<v-btn @click="dialogNewTemplate = true" dark color="primary" style="font-weight: 300;">
								<v-icon left small>fas fa-plus</v-icon>New Template
							</v-btn>
						</v-col>
						<v-col cols="12" class="pt-8">
							<v-card elevation="0" outlined>
								<v-data-table :loading="loading" theme-- light :headers="headers1"
									:items="inactiveapprovedtemplates" :footer-props="{
										'items-per-page-options': [5, 10, 15]
									}" :items-per-page="5" class="light table">
									<template v-slot:item.name="{ item }">
										{{ item.name }}
										<!-- <v-chip class="ma-2" color="info" label small v-if="item.flowDown">
											<v-icon left small>
												fas fa-turn-down
											</v-icon>
											Flow Down
										</v-chip> -->
									</template>
									<template v-slot:item.edit="{ item }">
										<v-btn small :to="'/auditonsite/onsitetemplates/' + item.templateID" color="primary"
											style="border-radius: 2px" label>
											{{ item.edit }}
											<v-icon small>fas fa-edit</v-icon>
										</v-btn>
									</template>
									<template v-slot:item.remove="{ item }">
										<v-btn v-on:click="makeitInactive(item)" v-if="item.active"
											class="error--text font-italic font-weight-bold">Deactivate</v-btn>
										<v-btn v-on:click="makeitActive(item)" v-else
											class="success--text font-weight-bold">Activate</v-btn>
									</template>
									<template v-slot:item.active="{ item }">
										<span v-if="item.active" class="success--text font-weight-bold">Active</span>
										<span v-else class="error--text font-italic font-weight-bold">Inactive</span>
									</template>
									<template v-slot:item.approval="{ item }">
										<span v-if="!!item.approval" class="success--text font-weight-bold">Approved</span>
										<span v-else class="error--text font-italic font-weight-bold">Not Approved</span>
									</template>
								</v-data-table>
							</v-card>
						</v-col>
					</v-tab-item>
					<v-tab-item>
						<v-col cols="12" class="pt-10">
							<h1 class="mb-2 font-weight-black darkColor--text">Onsite-Audit Template Overview</h1>
							<p class="mb-5 text-center font-weight-medium darkColor--text">This is an overview of the
								templates you have
								available.</p>
						</v-col>
						<v-col align="right" v-if="$accessToOperation('AT', 'C')">
							<v-btn @click="dialogNewTemplate = true" dark color="primary" style="font-weight: 300;">
								<v-icon left small>fas fa-plus</v-icon>New Template
							</v-btn>
						</v-col>
						<v-col cols="12" class="pt-8">
							<v-card elevation="0" outlined>
								<v-data-table :loading="loading" theme-- light :headers="headers2"
									:items="notapprovedtemplates" :footer-props="{
										'items-per-page-options': [5, 10, 15]
									}" :items-per-page="5" class="light table">
									<template v-slot:item.name="{ item }">
										{{ item.name }}
										<!-- <v-chip class="ma-2" color="info" label small v-if="item.flowDown">
											<v-icon left small>
												fas fa-turn-down
											</v-icon>
											Flow Down
										</v-chip> -->
									</template>
									<template v-slot:item.remove="{ item }">
										<v-btn small :disabled="!!item.approval" color="#B4B4B4" style="border-radius: 2px"
											v-on:click="showDeleteDialog(item)">
											<v-icon color="white" small>fas fa-times</v-icon>
										</v-btn>
									</template>
									<template v-slot:item.edit="{ item }">
										<v-btn small :to="'/auditonsite/onsitetemplates/' + item.templateID" color="primary"
											style="border-radius: 2px" label>
											{{ item.edit }}
											<v-icon small>fas fa-edit</v-icon>
										</v-btn>
									</template>
									<template v-slot:item.approval="{ item }">
										<span v-if="!!item.approval" class="success--text font-weight-bold">Approved</span>
										<span v-else class="error--text font-italic font-weight-bold">Not Approved</span>
									</template>
								</v-data-table>
							</v-card>
						</v-col>
					</v-tab-item>
				</v-tabs>
			</v-col>
			<v-dialog v-model="dialogDelete" max-width="500px">
				<v-card>
					<v-card-title class="justify-center"><span class="text-h4 pt-10 pb-3">Are you sure you want <br />to
							remove this template?</span></v-card-title>
					<v-card-actions class="justify-center pb-6">
						<v-btn color="primary" text @click="dialogDelete = false" outlined>Close</v-btn>
						<v-btn color="error" text @click="removeRow" outlined>Delete</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog v-model="dialogNewTemplate" max-width="800px">

				<v-card class="pl-7">
					<v-toolbar elevation="0" class="pr-0">
						<v-col align="right" class="pr-1">
							<v-btn icon @click="dialogNewTemplate = false">
								<v-icon large>fas fa-thin fa-times</v-icon>
							</v-btn>
						</v-col>
					</v-toolbar>
					<!-- <v-card-title class="justify-center">
						<v-button><v-icon>fa-solid fa-xmark-large</v-icon></v-button> -->
					<v-card-title>
						<span class="text-h5 font-weight-bold pt-12">What would you like to name your audit
							template?</span></v-card-title>
					<v-card-text class="pt-4">
						<v-text-field v-model="newTemplateName" label="Template Name" placeholder="Onsite-Audit template name"
							outlined></v-text-field>
					</v-card-text>
					<v-card-actions class="mt-0">
						<v-col class="text-right">
							<v-btn color="orangeButton" :disabled="!newTemplateName" class="ma-2 white--text"
								@click="createTemplate(newTemplateName)">CONTINUE</v-btn>
						</v-col>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-row>
	</v-container>
</template>


<script>
import TemplateAPI from "../../api/audit/template"
import LoadingState from "../../consts/LoadingState"
import { mapState } from "vuex"
export default {
	name: "OnsiteTemplateOverview",

	data() {
		return {
			headers: [
				// { text: "Template ID", value: "templateID", sortable: false, class: "black--text d-none"},
				{ text: "Name", value: "name", sortable: false, class: "darkColor--text" },
				{ text: "Approved", value: "approval", sortable: false, class: "darkColor--text" },
				{ text: "Status", value: "active", sortable: false, class: "darkColor--text" },
				{ text: "Edit", value: "edit", sortable: false, class: "darkColor--text" },
				{ text: "Deactivate", value: "remove", sortable: false, class: "darkColor--text" }
			],
			headers1: [
				// { text: "Template ID", value: "templateID", sortable: false, class: "black--text d-none"},
				{ text: "Name", value: "name", sortable: false, class: "darkColor--text" },
				{ text: "Approved", value: "approval", sortable: false, class: "darkColor--text" },
				{ text: "Status", value: "active", sortable: false, class: "darkColor--text" },
				{ text: "Edit", value: "edit", sortable: false, class: "darkColor--text" },
				{ text: "Activate", value: "remove", sortable: false, class: "darkColor--text" }
			],
			headers2: [
				// { text: "Template ID", value: "templateID", sortable: false, class: "black--text d-none"},
				{ text: "Name", value: "name", sortable: false, class: "darkColor--text" },
				{ text: "Approved", value: "approval", sortable: false, class: "darkColor--text" },
				{ text: "Edit", value: "edit", sortable: false, class: "darkColor--text" },
				{ text: "Remove", value: "remove", sortable: false, class: "darkColor--text" }
			],
			activetemplates: [],
			activeapprovedtemplates: [],
			inactiveapprovedtemplates: [],
			notapprovedtemplates: [],
			templateID: null,
			name: null,
			newTemplateName: null,
			dialogDelete: false,
			dialogNewTemplate: false,
			itemToDelete: null,
			loading: false,
			options: {},
			total: 0,
		}
	},
	mounted() {
		this.loadItems()
	},
	methods: {
		loadItems() {
			this.loading = true
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			const { page, itemsPerPage } = this.options
			TemplateAPI.getOnsiteActiveTemplates().then(data => {
				this.activeapprovedtemplates = []
				for (let entry of data.data) {
					this.activeapprovedtemplates.push({
						templateID: entry.ID,
						name: entry.Name,
						approval: entry.Approval,
						active: entry.Active,
					})
				}
				this.activeapprovedtemplates.reverse()
			}).catch(error => {
				this.loading = false
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					error,
					{ root: true }
				)
			})
			TemplateAPI.onsiteList({ offset: (page - 1) * itemsPerPage, limit: itemsPerPage })
				.then(data => {
					this.notapprovedtemplates = []
					for (let entry of data.items) {
						if (!entry.Approved) {
							this.notapprovedtemplates.push({
								templateID: entry.ID,
								name: entry.Name,
								approval: entry.Approved,
								remove: null,
								active: 1,
							})
						}
					}
					this.total = data.total
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					this.loading = false
				})
				.catch(error => {
					this.loading = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
			TemplateAPI.getOnsiteInactiveTemplates().then(data => {
				this.inactiveapprovedtemplates = []
				for (let entry of data.data) {
					this.inactiveapprovedtemplates.push({
						templateID: entry.ID,
						name: entry.Name,
						approval: entry.Approval,
						active: entry.Active
					})
				}
				this.inactiveapprovedtemplates.reverse()
			}).catch(error => {
				this.loading = false
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					error,
					{ root: true }
				)
			})
		},
		createTemplate(templateName) {
			TemplateAPI.addTemplate(templateName, null, null, null, 0, 1)
				.then((id) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully created template with ID '${id}'`,
						{ root: true }
					)

					// Navigate to the newly created template
					this.$router.push(`/auditonsite/onsitetemplates/${id}`)
				})
				.catch((error) => {
					// Extract backend errors if available
					const payload = error?.response?.data
					const backendErrors = payload?.error || payload?.errors

					if (backendErrors && backendErrors.length > 0) {
						this.localError = backendErrors.map(e => e.message).join("; ")
					} else {
						this.localError = error.message || "Something went wrong while adding the Action Plan."
					}

					// Dispatch error to Vuex
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						this.localError,
						{ root: true }
					)
				})
		},

		setSendingFalse: function () {
			this.isSending = false
		},
		showDeleteDialog(item) {
			this.itemToDelete = item
			this.dialogDelete = !this.dialogDelete
		},
		makeitInactive(item) {
			let index = this.activeapprovedtemplates.indexOf(item)
			item.active = 0
			this.activeapprovedtemplates.splice(index, 1)
			this.inactiveapprovedtemplates.push(item)
			TemplateAPI.updateActiveTemplates(item.templateID, item.active).then(() => {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
					"Template was successfully Inactivated.",
					{ root: true }
				)

			})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		makeitActive(item) {
			let index = this.inactiveapprovedtemplates.indexOf(item)
			item.active = 1
			this.inactiveapprovedtemplates.splice(index, 1)
			this.activeapprovedtemplates.push(item)
			TemplateAPI.updateActiveTemplates(item.templateID, item.active).then(() => {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
					"Template was successfully Activated.",
					{ root: true }
				)

			})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		removeRow() {
			this.dialogDelete = false
			let index = this.notapprovedtemplates.indexOf(this.itemToDelete)
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)

			TemplateAPI.deleteTemplate(this.itemToDelete.templateID)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Template was successfully removed from the list.",
						{ root: true }
					)
					this.notapprovedtemplates.splice(index, 1)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		}
	},
	computed: {
		...mapState("loading", {
			loading: state => state.loading == LoadingState.LOADING
		})
	}
}
</script>
<style scoped>
.v-text-field--outlined>>>fieldset {
	border-color: lightgrey;
}

.v-text-field label {
	color: darkColor;
}
</style>
